import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/ui/spinner";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

type SplitPdfLoadingProps = {
  onCancel: () => void;
};

export default function SplitPdfLoading({ onCancel }: SplitPdfLoadingProps) {
  const { t } = useTranslation();
  return (
    <div className="relative flex flex-1 h-full items-center justify-center w-full">
      <div className="absolute top-4 left-4">
        <Button variant="ghost" onClick={onCancel} className="gap-2">
          <X className="w-4 h-4" />
          {t("cancel")}
        </Button>
      </div>
      <div className="flex flex-col items-center gap-4">
        <LoadingSpinner className="w-16 h-16" />
        <div className="text-center">
          <div className="text-base font-medium">
            {t("pdf_edit_loading_title")}
          </div>
          <div className="text-sm text-muted-foreground">
            {t("pdf_edit_loading_description")}
          </div>
        </div>
      </div>
    </div>
  );
}
